// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__31k0j","tooltip-icon":"Tooltip_tooltip-icon__3iikJ","link":"Tooltip_link__I6xmi","tooltip-content":"Tooltip_tooltip-content__gXjp0"};